import React from 'react';
import './index.css';
import activeProfileTaxStatus from 'images/activeProfileTaxStatus.svg';

const NonIndiVidualProfileView = () => {
    return (
        <div className='activeProfileTaxStatus'>
            <img src={activeProfileTaxStatus} alt="active profile" />
            <h3>Manage your account details securely</h3>
            <p>Your account is activated. Information cannot be updated now. Please contact your advisor for further help.</p>
        </div>
    )
}

export default NonIndiVidualProfileView
